import { Pipe, PipeTransform } from '@angular/core';
import { Location } from '@angular/common';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';

import { UserState } from '@hiptraveler/data-access/user';
import { ItineraryState } from '@hiptraveler/data-access/itinerary';

@Pipe({
  name: 'editVisibility'
})
export class EditVisibilityPipe implements PipeTransform {

  constructor(
    private location: Location,
    private store: Store
  ) { }

  transform(_: unknown): Observable<boolean> {

    const pageTitle = this.store.selectSnapshot(UserState.profileId)!
    const profilePage = `profile/${decodeURIComponent(pageTitle)}/uploads`;

    return this.store.select(ItineraryState.imageInformation).pipe(
      map(response => !!response && [
      profilePage,
      // ...
    ].some(path => decodeURIComponent(this.location.path()).includes(path))));
  }

}
